import { render } from "./ToBeShippedSolve.vue?vue&type=template&id=1801672d&scoped=true"
import script from "./ToBeShippedSolve.vue?vue&type=script&lang=js"
export * from "./ToBeShippedSolve.vue?vue&type=script&lang=js"

import "./ToBeShippedSolve.vue?vue&type=style&index=0&id=1801672d&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1801672d"]])

export default __exports__